import { getCountryCallingCode } from 'libphonenumber-js';
import { getCountrySelectOptions } from './country';

export const getCountryCodeSelectOptions = () => getCountrySelectOptions().map((country) => ({
  ...country,
  countryCode: country.value,
  value: `+${getCountryCallingCode(country.value)}`,
}));

export const countryCodes = getCountryCodeSelectOptions();
